import { FC, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Button, Grid } from '@mui/material';

import { Photo } from '@mui/icons-material';

import ErrorMessage from '../../sharedModules/layout/ErrorMessage';
import LoadingWrapper from '../../sharedModules/layout/LoadingWrapper';
import PageHeader from '../../sharedModules/layout/PageHeader';
import PhotoProposalImageGrid from '../components/PhotoProposalImageGrid';
import PhotoProposalTitleEditField from '../components/PhotoProposalTitleEditField';

import { PhotoProposal } from '../model';

import axios from '../../sharedModules/utils/axios.utils';

const PhotoProposalDetailPage: FC = () => {
  const { xoiJobId } = useParams<{ xoiJobId: string }>();

  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [allXoiPhotos, setAllXoiPhotos] = useState<any[]>();
  const [photoProposal, setPhotoProposal] = useState<PhotoProposal>();

  const fetchPhotoProposal = async () => {
    setLoading(true);
    try {
      const response: any = await axios.get(`/photo_proposals/photo_proposals/${xoiJobId}`);
      setPhotoProposal(response.data.photo_proposal);
      setAllXoiPhotos(response.data.all_xoi_photos);
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPhotoProposal();
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <ErrorMessage message={errorMessage} />
      </Grid>
      <Grid item xs={12}>
        <LoadingWrapper isLoading={loading}>
          <PageHeader
            titleIcon={<Photo />}
            mainTitle={photoProposal?.title}
            subTitle={photoProposal?.work_order_number}
            backButtonLabel="Xoi Jobs"
            backButtonLink="/photo_proposals"
          />
        </LoadingWrapper>
      </Grid>
      <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
        <PhotoProposalTitleEditField photoProposal={photoProposal} fetchPhotoProposal={fetchPhotoProposal} />
      </Grid>
      <Grid item xs={12}>
        <PhotoProposalImageGrid
          photoProposal={photoProposal}
          fetchPhotoProposal={fetchPhotoProposal}
          allXoiPhotos={allXoiPhotos}
        />
      </Grid>
    </Grid>
  );
};

export default PhotoProposalDetailPage;
